<template>
  <v-card
    class="d-flex flex-column secondary--text justify-center"
    min-height="550"
  >
    <div
      class="pa-10 d-flex flex-column align-center"
      style="min-height: 500px"
    >
      <i :class="`icofont-exclamation-circle icofont-6x accent--text`" />

      <div
        class="mb-4 custom-title secondary--text font-weight-medium text-center"
      >
        Conflicting Event
      </div>
      <div class="text-left mx-8">{{ bodyText }}</div>
      <div
        class="mt-8 text-center secondary--text font-weight-medium"
        style="font-size: 20px"
      >
        How would you like to proceed?
      </div>
    </div>
    <div>
      <v-btn
        depressed
        tile
        style="width: 50%"
        class="white--text text-center pa-8 font-weight-medium mt-auto capital--btn accent_light"
        @click="close"
      >
        <span class="" style="font-weight: 600 !important">CANCEL</span>
      </v-btn>
      <v-btn
        tile
        style="width: 50%"
        class="white--text text-center pa-8 font-weight-medium mt-auto capital--btn accent"
        @click="$emit('accessEvent')"
      >
        <span class="" style="font-weight: 600 !important">ACCESS EVENT</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "EventConflictDialog",
  components: {},
  props: {
    bodyText: {
      type: String,
      default:
        "The event you are trying to create conflicts with a prior event already created.",
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close:dialog");
    },
  },
};
</script>

<style></style>
